import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PrivacypolicyRoutingModule } from './privacypolicy-routing.module';
import { PrivacypolicyComponent } from './privacypolicy.component';

@NgModule({
  imports: [
    CommonModule,
    PrivacypolicyRoutingModule
  ],
  declarations: [PrivacypolicyComponent]
})
export class PrivacypolicyModule { }



// WEBPACK FOOTER //
// /Volumes/Projects/WellBrain_Azure_Web/src/app/components/privacypolicy/privacypolicy.module.ts